import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  messageContainer: {
    marginTop: theme.spacing(1.5),
    textAlign: 'right',
  },
}));

export default useStyles;
